module.exports = __webpack_public_path__ + "logo.png?db3a3f351a533abcf7cced9a9dc2cd15";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = 16
// module chunks = 0